var L = Object.defineProperty;
var S = (n, e, r) => e in n ? L(n, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : n[e] = r;
var c = (n, e, r) => S(n, typeof e != "symbol" ? e + "" : e, r);
import { uuidv7 as f } from "uuidv7";
import h from "../node_modules/.pnpm/uuid@9.0.1/node_modules/uuid/dist/esm-browser/v5.js";
const t = class t {
  /**
   * Generates a random string of specified length using the given character set
   */
  static generateString(e = t.DEFAULT_LENGTH, r = t.DEFAULT_CHARS) {
    let i = "";
    const s = r.length;
    for (let a = 0; a < e; a++) {
      const A = Math.floor(Math.random() * s);
      i += r.charAt(A);
    }
    return i;
  }
  /**
   * Generates a unique random string with duplicate checking
   *
   * @param isUnique - Function that returns true if the candidate string is unique (doesn't exist)
   * @param options - Configuration options for string generation
   * @param maxAttempts - Maximum attempts before falling back to timestamp suffix
   * @returns Promise resolving to a unique random string
   */
  static async generateUniqueString(e, r = {}, i = t.DEFAULT_MAX_ATTEMPTS) {
    const {
      length: s = t.DEFAULT_LENGTH,
      chars: a = t.DEFAULT_CHARS
    } = r;
    for (let o = 0; o < i; o++) {
      const u = t.generateString(s, a);
      if (await e(u))
        return u;
    }
    const A = Math.max(1, s - 2), T = t.generateString(A, a), g = Date.now().toString().slice(-2);
    return T + g;
  }
  /**
   * Generates a UUID v7 (timestamp-based and sortable)
   */
  static uuid() {
    return f();
  }
  /**
   * Generates a deterministic UUID v5 from `name`: the same input always yields
   * the same id. Used to derive a stable primary key for imported health-store
   * readings (e.g. `source|externalId`) so re-imports collide on the PK and the
   * PowerSync `ON CONFLICT(id)` upsert is idempotent — no duplicate rows. Works
   * in Node and React Native (isomorphic `uuid`), unlike `expo-crypto`.
   */
  static deterministicUuid(e) {
    return h(e, t.NAMESPACE);
  }
};
c(t, "DEFAULT_CHARS", "abcdefghijklmnopqrstuvwxyz0123456789"), c(t, "DEFAULT_LENGTH", 8), c(t, "DEFAULT_MAX_ATTEMPTS", 50), /**
 * Fixed namespace for Fytness deterministic (v5) UUIDs. Kept stable forever —
 * changing it would re-key every previously imported record.
 */
c(t, "NAMESPACE", "6f3b9c7e-2d41-4b8a-9e6f-1a2b3c4d5e6f");
let E = t;
export {
  E as RandomUtils
};
